/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';
import {
  getTitlePreview,
  getDescPreview,
  combineDescriptions,
} from '@bingads-webui-campaign/summary-grid-helper';
import { evaluateAdCustomizers as newEvaluateAdCustomizers } from '@bingads-webui-campaign/ad-customizers';
import { evaluateAdCustomizers as legacyEvaluateAdCustomizers } from '@bingads-webui-campaign-legacy/crud-ad/service/adCustomizersUtils';
import { getExpandedTextAdDisplayUrl } from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import config from '@bingads-webui-component-legacy/config/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import { i18nDummy } from '@bingads-webui-campaign-legacy/crud-ad/service/utils/i18n-dummy-vnext';

const i18nAdCustomizers = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/ad-customizers');

const {
  IsNewAdsAdCustomizerEditorEnabled,
  IsIfFunctionMilestone1Enabled,
} = config.get('Permissions') || {};

const withNewAdCustomizerEditor = IsNewAdsAdCustomizerEditorEnabled ||
  IsIfFunctionMilestone1Enabled;

const evaluateAdCustomizers = (text, fieldName) => {
  if (withNewAdCustomizerEditor) {
    return newEvaluateAdCustomizers({
      text,
      field: fieldName,
      deps: {
        config,
        i18n: i18nAdCustomizers,
        countdownI18nDummy: i18nDummy,
        instrumentation,
        jsDataCampaign,
        edmCampaign,
      },
      adType: 'ResponsiveSearchAd',
    });
  }
  return legacyEvaluateAdCustomizers(text);
};


function getFormattedField(fields, model) {
  return _.chain(fields)
    .filter((field) => !_.isEmpty(_.result(model[`Parsed${field}`](), 'trim')))
    .map((field) => ({
      Text: model[`Parsed${field}`]().trim(),
      PinnedField: model[`Parsed${field}Position`](),
    }))
    .value();
}
export default class ViewModel {
  constructor(adViewModel = {}) {
    const headlineFields = config.get('headlineFields');
    const descriptionFields = config.get('descriptionFields');
    const self = this;
    const fields = [
      'Path1',
      'Path2',
      ...headlineFields,
      ...descriptionFields,
      ..._.map(headlineFields, (i) => `${i}Position`),
      ..._.map(descriptionFields, (i) => `${i}Position`),
    ];

    this.placeHolders = adViewModel.placeholders;

    _.each(fields, (fieldName) => {
      self.createField(`Parsed${fieldName}`, adViewModel[fieldName]);
    });

    this.Text = ko.computed(() => {
      const descriptions = getFormattedField(descriptionFields, self);
      const descriptionText = getDescPreview(descriptions);

      return _.isEmpty(descriptionText) ? combineDescriptions(self.placeHolders.Description1, self.placeHolders.Description2) : descriptionText;
    });

    this.Title = ko.computed(() => {
      const headlines = getFormattedField(headlineFields, self);
      const headlinesText = getTitlePreview(headlines);

      return _.isEmpty(headlinesText) ? [
        self.placeHolders.Headline1,
        self.placeHolders.Headline2,
        self.placeHolders.Headline3,
      ].join(' | ') : headlinesText;
    });

    this.DisplayUrl = ko.computed(() => {
      return getExpandedTextAdDisplayUrl(_.first(adViewModel.FinalUrls()), adViewModel.DisplayUrl(), self.ParsedPath1(), self.ParsedPath2(), true);
    });

    this.DestinationUrl = ko.computed(() => {
      return adViewModel.FinalUrls();
    });
  }

  /**
   * Adds a property to this that holds parsed value of passed dependency
   * @param {string} fieldName - new property's name
   * @param {Object} dependency - observable that contains the raw value to be parsed for preview
   * @returns {undefined}
   */
  createField(fieldName, dependency) {
    const self = this;

    this[fieldName] = ko.observable(dependency());
    evaluateAdCustomizers(dependency(), fieldName).then((value) => {
      self[fieldName](value);
    });

    // We cannot directly use computedObservables because evaluateAdCustomizers is async
    dependency.subscribe(() => {
      evaluateAdCustomizers(dependency(), fieldName).then((value) => {
        self[fieldName](value);
      });
    });
  }
}
